<template>
    <div class="p-campaign2024 | l-inner">
        <app-section
            :title="pageHeading"
            :desc="page.desc"
            :push="page.push"
            bgIntro="lighter"
            :image="page.image_hero"
            intro-position="bottom"
            :page="page"
            :image-has-background="true"
        >
            <template #content>
                <div class="p-campaign2024__grid | l-grid">
                    <div v-for="(item, index) in page.body" :key="index" class="p-campaign2024__grid__body">
                        <hero-card v-if="item.slice_type === 'card_hero'" :data="item" />
                        <social-medias-block v-if="item.slice_type === 'social_medias'" :data="item" />
                        <entrepreneur-parallax :item="item" v-if="item.slice_type === 'parallax'" :data="item" />
                    </div>
                </div>
            </template>
        </app-section>
        <about />
    </div>
</template>

<script>
import { mapState } from "vuex";

import About from "layout/About";
import AnimText from "objects/AnimText";
import AppSection from "layout/AppSection";
import EntrepreneurParallax from "components/EntrepreneurParallax/EntrepreneurParallax";
import EntrepreneurQuote from "components/EntrepreneurQuote/EntrepreneurQuote";
// import EntrepreneurThumbnail from "components/EntrepreneurThumbnail/EntrepreneurThumbnail";
// import EntrepreneurTitleText from "components/EntrepreneurTitleText/EntrepreneurTitleText";
// import EntrepreneurVerticalName from "components/EntrepreneurVerticalName/EntrepreneurVerticalName";
// import EntrepreneurVideo from "components/EntrepreneurVideo/EntrepreneurVideo";
import HeroCard from "components/HeroCard/HeroCard";
import Icon from "objects/Icon";
import SocialMediasBlock from "components/SocialMediasBlock/SocialMediasBlock";

export default {
    name: "Campaign2024",
    components: {
        About,
        AnimText,
        AppSection,
        EntrepreneurParallax,
        EntrepreneurQuote,
        // EntrepreneurThumbnail,
        // EntrepreneurTitleText,
        // EntrepreneurVerticalName,
        // EntrepreneurVideo,
        HeroCard,
        Icon,
        // Push
        SocialMediasBlock
    },
    props: {
        page: Object
    },
    data() {
        return {};
    },
    computed: {
        ...mapState({
            currentPage: state => state.global.currentPage
        }),
        pageHeading() {
            return this.page.heading[0].text || this.page.title;
        }
    },
    methods: {
        ////////////////////////////////
        //       START FIND A DATA BY SLICE TYPE
        ////////////////////////////////
        findCard(sliceType, data) {
            return data.find(x => x.slice_type === sliceType);
        }
        ////////////////////////////////
        //       END FIND A DATA BY SLICE TYPE
        ////////////////////////////////
    }
};
</script>

<style lang="scss">
.p-campaign2024__grid__body {
    display: flex;
    height: 100%;
}
</style>
